<template>
    <div class="tangying" id="tangying">
    </div>
</template>


<script>
import { Button, Row, Col, Image } from 'element-ui';

export default {

    components: {
    },
    watch: {
    },
    data() {
        return {
            // 颜色
            colorList: [
                '#f7e0b8',
                '#bdeaec',
                '#eceef9',
                '#eebed1',
                '#ccc3e2',
                '#f8e9e3',
                '#f6f0e0',
                '#e8f6fa',
                '#f6cfd1',
                '#eff1ca',
                '#cde5c9',
            ],
            // 文字
            textList: [
                '今天也爱你。❤️',
                '想你啦，宝贝。😘',
                '梦里你说想我，然后我就笑醒了。😴',
                '在干嘛？想你了。🤔',
                '梦到你，好甜。😴',
                '你超可爱！🐣',
                '刚刚又在脑子里偷偷想你了。😘',
                '抱一下？现在。🤗',
                '今天也是想黏着你的一天。❤️',
                '晚安，我的光。🌙',
                '醒啦，想你呀。☀️',
                '就喜欢黏你。😊',
                '你在，心就安。✨',
                '今天有没有比昨天更爱我？🤔',
                '今天更爱你了。🔥',
                '什么时候见面呀？🥺',
                '你最好看了。👀',
                '我乖，求夸。🐶',
                '别太累，心疼。💔',
                '你忙完了记得第一个找我。🥺',
                '有你真好。🍬',
                '脑袋里全是你。🧠',
                '理我一下嘛。🥺',
                '你像糖，好甜。🍬',
                '想钻进你怀里。🐨',
                '今天超乖的。✨',
                '你一笑我就觉得世界好甜。🍬',
                '赖在你怀里不走。🐱',
                '你忙，我等你。⏳',
                '想听你声音。🎧',
                '我心里都炸开了一小朵烟花。🎆',
                '你不在，无聊。😕',
                '就是突然好想你。💭',
                '你不在的时候我好无聊啊。😕',
                '心里装不下别人。🔒',
                '见到你，开心。😆',
                '你比猫可爱。🐱',
                '别着凉了。🌡️',
                '我的，不许跑。🫵',
                '我感觉自己越来越离不开你了。🔒',
                '你就像每天都想喝的那杯奶茶。🧋',
                '我刚刚发呆，全是在想你。💭',
                '晚安，今晚要梦到我哦。🌙'

            ]
        }
    },
    mounted() {
        document.title = "";

        const tangying = document.getElementById('tangying')

        // 高斯分布函数（生成集中在中心的位置）
        function gaussianRandom(mean = 0, stdev = 1) {
            let u = 0, v = 0;
            while (u === 0) u = Math.random();
            while (v === 0) v = Math.random();
            const z = Math.sqrt(-2.0 * Math.log(u)) * Math.cos(2.0 * Math.PI * v);
            return mean + z * stdev;
        }

        for (let i = 0; i < 150; i++) {
            setTimeout(() => {
                // 创建的 div
                const div = document.createElement('div');
                div.className = 'my-absolute-div'

                const span = document.createElement('span');

                // 随机获取一个元素
                const colorIndex = Math.floor(Math.random() * this.colorList.length);
                const textIndex = Math.floor(Math.random() * this.textList.length);
                div.style.backgroundColor = this.colorList[colorIndex]
                span.innerText = this.textList[textIndex]
                span.style.fontSize = '14px'
                span.style.fontWeight = 'bold'
                span.style.margin = '10px'
                div.appendChild(span)
                tangying.appendChild(div)

                // 获取实际尺寸
                const rect = div.getBoundingClientRect();
                const divWidth = rect.width;
                const divHeight = rect.height;

                // 计算中心位置
                const centerX = window.innerWidth / 2 - divWidth / 2;
                const centerY = window.innerHeight / 2 - divHeight / 2;

                // 标准差（控制分散程度，数值越小越集中）
                const stdDev = Math.min(window.innerWidth, window.innerHeight) / 6;

                // 使用高斯分布生成位置（集中在中心）
                let randomX = centerX + gaussianRandom(0, stdDev);
                let randomY = centerY + gaussianRandom(0, stdDev);

                // 限制边界，避免溢出
                const maxX = window.innerWidth - divWidth;
                const maxY = window.innerHeight - divHeight;
                randomX = Math.min(maxX, Math.max(0, randomX));
                randomY = Math.min(maxY, Math.max(0, randomY));

                // 重新设置位置
                div.style.left = randomX + 'px';
                div.style.top = randomY + 'px';
            }, i * 20); // 每个延迟 100ms
        }

    },
    methods: {

    },
    beforeDestroy() {
    },

}
</script>

<style lang="less">
.tangying {
    position: relative;
    width: 100vw;
    height: 100vh;
    background-color: #f3dbdc;
    // border: 1px solid red;
    touch-action: manipulation;
    /* 允许点击，但禁用双指缩放 */
    user-select: none;
    /* 禁止文本选择，防止双击选中文字 */

    @keyframes zoomIn {
        from {
            transform: translate(0, 0) scale(0);
        }

        to {
            transform: translate(0, 0) scale(1);
        }
    }

    .my-absolute-div {
        position: absolute;
        min-width: 100px;
        min-height: 50px;
        // border: 1px solid red;
        border-radius: 10px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        display: flex;
        align-items: center;
        justify-content: center;

        // transform: translate(-50%, -50%) scale(0);
        animation: zoomIn 0.2s ease-out forwards;
    }

}
</style>